import {ZipCodeFormatWebViewModel} from "@modules/onBoarding/presentation/viewModel/ZipCodeFormatWebViewModel";
import {
    ValidateZipCodeFormatPresenter
} from "@modules/onBoarding/application/port/ValidateZipCodeFormatPresenter";

export class ValidateZipCodeFormatWebPresenter implements ValidateZipCodeFormatPresenter {

    private viewModel: ZipCodeFormatWebViewModel = {
        isValidZipCode: false,
        errorMessage: null
    }

    notifyZipCodeIsInvalid(errorMessage: string): void {
        this.viewModel.errorMessage = errorMessage;
        this.viewModel.isValidZipCode = false;
    }

    notifyZipCodeIsValid(): void {
        this.viewModel.errorMessage = null;
        this.viewModel.isValidZipCode = true;
    }

    getViewModel(): ZipCodeFormatWebViewModel {
        return this.viewModel;
    }

}
